{
  "id": "rusticShelf",
  "name": "Rustic Pallet Shelf",
  "builds": "product",
  "category": "rustic",
  "note": "Six boards off one pallet — and the pallet gives the nails back too.",
  "skill": "rusticCarpentry",
  "duration": 30,
  "offeredBy": "hammer",
  "fastener": "nails",
  "value": 12,
  "widthIn": 38,
  "heightIn": 36,
  "slots": [
    {
      "id": "support-0",
      "role": "support",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 19,
      "yIn": 14.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "support-1",
      "role": "support",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 19,
      "yIn": 32.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "side-0",
      "role": "side",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 0.5,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "side-1",
      "role": "side",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 37.5,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "shelf-0",
      "role": "shelf",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 19,
      "yIn": 12,
      "angleDeg": 90,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "shelf-1",
      "role": "shelf",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board",
        "species": "pallet"
      },
      "xIn": 19,
      "yIn": 30,
      "angleDeg": 90,
      "zIn": 0,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 0,
      "yIn": 15.5,
      "level": {
        "headingDeg": 270,
        "zIn": 0.5
      }
    },
    {
      "xIn": 0,
      "yIn": 13.5,
      "level": {
        "headingDeg": 270,
        "zIn": 0.5
      }
    },
    {
      "xIn": 38,
      "yIn": 15.5,
      "level": {
        "headingDeg": 90,
        "zIn": 0.5
      }
    },
    {
      "xIn": 38,
      "yIn": 13.5,
      "level": {
        "headingDeg": 90,
        "zIn": 0.5
      }
    },
    {
      "xIn": 0,
      "yIn": 33.5,
      "level": {
        "headingDeg": 270,
        "zIn": 0.5
      }
    },
    {
      "xIn": 0,
      "yIn": 31.5,
      "level": {
        "headingDeg": 270,
        "zIn": 0.5
      }
    },
    {
      "xIn": 38,
      "yIn": 33.5,
      "level": {
        "headingDeg": 90,
        "zIn": 0.5
      }
    },
    {
      "xIn": 38,
      "yIn": 31.5,
      "level": {
        "headingDeg": 90,
        "zIn": 0.5
      }
    },
    {
      "xIn": 0,
      "yIn": 12,
      "level": {
        "headingDeg": 270,
        "zIn": 1
      }
    },
    {
      "xIn": 0,
      "yIn": 12,
      "level": {
        "headingDeg": 270,
        "zIn": 3
      }
    },
    {
      "xIn": 38,
      "yIn": 12,
      "level": {
        "headingDeg": 90,
        "zIn": 1
      }
    },
    {
      "xIn": 38,
      "yIn": 12,
      "level": {
        "headingDeg": 90,
        "zIn": 3
      }
    },
    {
      "xIn": 0,
      "yIn": 30,
      "level": {
        "headingDeg": 270,
        "zIn": 1
      }
    },
    {
      "xIn": 0,
      "yIn": 30,
      "level": {
        "headingDeg": 270,
        "zIn": 3
      }
    },
    {
      "xIn": 38,
      "yIn": 30,
      "level": {
        "headingDeg": 90,
        "zIn": 1
      }
    },
    {
      "xIn": 38,
      "yIn": 30,
      "level": {
        "headingDeg": 90,
        "zIn": 3
      }
    }
  ]
}
